import React from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';
import { BiTrendingUp } from 'react-icons/bi';

import SpanLoader from 'partial/components/SpanLoader';

function CountCard({
  name,
  label,
  icon: Icon,
  iconClassName,
  hook: useCountCard,
  // filter,
}) {
  const [isLoading, value] = useCountCard(name);
  return (
    <div className="px-4 py-5 sm:p-6 bg-white rounded-xl shadow-md">
      <dt>
        <div
          className={cn(
            'absolute rounded-xl p-3',
            { 'animate-pulse': isLoading },
            iconClassName
          )}
        >
          <Icon className="h-7 w-7 text-primary-600" aria-hidden="true" />
        </div>
        <div className="ml-16 text-2xl font-semibold text-gray-800">
          <SpanLoader isLoading={isLoading} width="80px">
            {value ?? '--'}
          </SpanLoader>
        </div>
      </dt>
      <dd className="mt-1 ml-16 flex space-x-2 items-baseline md:block lg:flex">
        <p className="flex items-baseline text-sm text-gray-800 font-light">
          {label}
        </p>
      </dd>
    </div>
  );
}

CountCard.defaultProps = {
  icon: BiTrendingUp,
  iconClassName: 'bg-primary-50',
  hook: () => [false, null],
  // filter: {},
};

CountCard.propTypes = {
  hook: PropTypes.func,
  iconClassName: PropTypes.string,
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  // filter: PropTypes.instanceOf(Object),
  icon: PropTypes.instanceOf(Object),
};

export default CountCard;
